import * as React from 'react';

function CheckmarkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m6.043 12.938 3.071 2.875-3.07-2.875Zm16.402-7.504a1.665 1.665 0 0 0-2.244 0L9.114 15.813 5.619 12.54a1.665 1.665 0 0 0-2.244 0 1.42 1.42 0 0 0 0 2.102l4.617 4.322c.31.29.716.435 1.122.435a1.64 1.64 0 0 0 1.122-.435L22.445 7.535c.62-.58.62-1.52 0-2.1Z"
  }));
}

export { CheckmarkIcon };
